import {Component, Input, OnInit} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {MatIcon} from '@angular/material/icon';
import {MatAnchor} from '@angular/material/button';
import {DatePipe, NgIf, NgOptimizedImage} from '@angular/common';
import {MatCard} from '@angular/material/card';
import {HeadlineTextComponent} from "../headline-text/headline-text.component";

@Component({
  selector: 'headline-with-icon',
  templateUrl: './headline-with-icon.component.html',
  styleUrls: ['./headline-with-icon.component.scss'],
  standalone: true,
  imports: [MatCard, NgIf, MatAnchor, MatIcon, DatePipe, TranslateModule, NgOptimizedImage, HeadlineTextComponent]
})
export class HeadlineWithIconComponent implements OnInit {

  @Input() headline!: string;
  @Input() text!: string;
  @Input() icon!: string;

  ngOnInit(): void {
    if (!this.icon) this.icon = "success";
  }
}
